import ArchiveBadge from "./ArchiveBadge";
import { formatDate, prettyValue } from "../../js/utils/formatters";

export default function MessageThreadList({ items, selectedKey, onSelect }) {
  if (!items.length) {
    return <p className="field-hint messages-list-empty">Nothing to show in this view yet.</p>;
  }

  return (
    <ul className="messages-list">
      {items.map((item) => {
        const selected = item.key === selectedKey;
        return (
          <li key={item.key}>
            <button
              type="button"
              className={`messages-list__item${selected ? " is-selected" : ""}`}
              onClick={() => onSelect(item)}
            >
              <span className="messages-list__top">
                <strong>{item.title}</strong>
                {item.unread ? <span className="unread-pip">{item.unread}</span> : null}
              </span>
              <span className="messages-list__meta">
                {item.clientName || "Client"}
                {item.clientRole ? ` · ${prettyValue(item.clientRole)}` : ""}
                {item.agentName ? ` · ${item.agentName}` : ""}
              </span>
              <span className="messages-list__preview">{item.lastPreview}</span>
              <span className="messages-list__foot">
                <time>{formatDate(item.lastAt)}</time>
                <ArchiveBadge transaction={item.transaction} thread={item.thread} />
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
